import { render } from "./quick-add-to-cart.vue?vue&type=template&id=15edf1fd"
import script from "./quick-add-to-cart.vue?vue&type=script&lang=js"
export * from "./quick-add-to-cart.vue?vue&type=script&lang=js"

import "./quick-add-to-cart.vue?vue&type=style&index=0&id=15edf1fd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__